import { render, staticRenderFns } from "./FileDisplay.vue?vue&type=template&id=6a01cb0c&scoped=true"
import script from "./FileDisplay.vue?vue&type=script&lang=js"
export * from "./FileDisplay.vue?vue&type=script&lang=js"
import style0 from "./FileDisplay.vue?vue&type=style&index=0&id=6a01cb0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a01cb0c",
  null
  
)

export default component.exports